import classNames from 'classnames';
import { Link } from 'react-router-dom';

import { Box } from 'ui/box';
import Icons from 'assets/icons';

interface NavButtonProps {
  link?: string;
  text: string;
  customClass?: string;
  state?: unknown;
}

const NavButton = ({
  link,
  text,
  customClass,
  state,
}: NavButtonProps): React.JSX.Element => {
  const isExternal = !!link && /^https?:\/\//.test(link);
  const isMailto = !!link && /^mailto:/.test(link);
  const [pathname, query] = link?.split('?') ?? [];
  const search = query ? `?${query}` : undefined;

  const content = (
    <>
      <Box
        sx={{ fontSize: '0.875rem', lineHeight: '1.25rem', fontWeight: 600 }}
      >
        {text}
      </Box>
      <Icons.DoubleArrow customClass="h-2.5 w-2.5" />
    </>
  );

  const classes = classNames(
    'flex items-center gap-1.5 text-blue-800 hover:gap-2 hover:text-navy-800 transition-all',
    customClass
  );

  return (
    <Box sx={{ display: 'inline-flex' }}>
      {isExternal || isMailto ? (
        <a
          href={link}
          {...(isExternal ? { target: '_blank' } : {})}
          className={classes}
        >
          {content}
        </a>
      ) : (
        <Link to={{ pathname, search, state } as never} className={classes}>
          {content}
        </Link>
      )}
    </Box>
  );
};

export default NavButton;
